import React, { useState } from 'react';
import { useLeadSubmit } from '../../hooks/useLeadSubmit';
import { ValuationCard } from './valuation/ValuationCard';
import { ValuationStepAddress } from './valuation/ValuationStepAddress';
import { ValuationStepContact } from './valuation/ValuationStepContact';

const EMPTY_FORM = { name: '', phone: '', email: '', address: '', smsConsent: false };

const toPayload = (f) => ({ name: f.name, phone: f.phone, email: f.email, address: f.address, sms_consent: f.smsConsent });

// Progressive 2-step Home Valuation lead form (address first, then contact).
// `variant` suffixes ids/test-ids so two forms can coexist on one page.
export const HomeValuationForm = ({ openPrivacyPolicy, headingLevel = 'h3', variant = '' }) => {
  const suffix = variant ? `-${variant}` : '';
  const [step, setStep] = useState(1);
  const [form, setForm] = useState(EMPTY_FORM);
  const update = (patch) => setForm((prev) => ({ ...prev, ...patch }));
  const valuation = useLeadSubmit({
    endpoint: '/leads/home-valuation',
    errorLabel: 'home valuation lead',
    onSuccess: () => { setForm(EMPTY_FORM); setStep(1); },
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (step === 1) {
      if (form.address.trim()) setStep(2);
      return;
    }
    valuation.submit(toPayload(form));
  };

  return (
    <ValuationCard headingLevel={headingLevel}>
      <form onSubmit={handleSubmit} className="space-y-5" data-testid={`home-valuation-form${suffix}`}>
        {step === 1 ? (
          <ValuationStepAddress address={form.address} onChange={(address) => update({ address })} suffix={suffix} />
        ) : (
          <ValuationStepContact form={form} update={update} onEdit={() => setStep(1)} openPrivacyPolicy={openPrivacyPolicy} submitted={valuation.submitted} submitting={valuation.submitting} suffix={suffix} />
        )}
      </form>
    </ValuationCard>
  );
};
